<template>
	<view class="box">
		<view class="box-search">
			<u-search placeholder="搜索商品" height="30" searchIconColor="#999999" borderColor="#eeeeee"
				bgColor="#F9F9FB" :showAction="false" v-model="keyword" />
		</view>
		<view class="box-city">
			<view class="box-city-left">
				<image src="/static/logo.png" mode="widthFix"></image>
				<text>合肥</text>
			</view>
			<view class="box-city-right">重新定位</view>
		</view>
		<view class="list">
			<view class="list-item">
				<view class="list-item-val" style="color: #999;">A</view>
			</view>
			<view class="list-item">
				<view class="list-item-val">阿克苏</view>
			</view>
		</view>
		<view class="tips">
			<view class="tips-row active">A</view>
			<view class="tips-row">B</view>
			<view class="tips-row">C</view>
			<view class="tips-row">D</view>
			<view class="tips-row">E</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				keyword: ''
			};
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 30rpx;
		box-sizing: border-box;
		.tips {
			position: fixed;
			right: 20rpx;
			top: 50%;
			transform: translate(-50%, 0);
			display: flex;
			flex-direction: column;
			.active {
				color: #004096 !important;
			}
			.tips-row {
				font-weight: 400;
				font-size: 22rpx;
				color: #333333;
				margin-bottom: 10rpx;
			}
		}
		.list {
			width: 100%;
			margin-top: 54rpx;
			.list-item {
				width: 100%;
				height: 100rpx;
				display: flex;
				align-items: center;
				border-bottom: 1rpx solid #E5E5E5;
				.list-item-val {
					font-weight: 400;
					font-size: 30rpx;
					color: #333333;
				}
			}
		}
		.box-search {
			width: 100%;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 999;
			background-color: #ffffff;
		}
		.box-city {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 40rpx;
			.box-city-left {
				display: flex;
				align-items: center;
				image {
					width: 28rpx;
					height: 28rpx;
					margin-right: 20rpx;
				}
				text {
					font-weight: 500;
					font-size: 30rpx;
					color: #222222;
				}
			}
			.box-city-right {
				font-weight: 400;
				font-size: 28rpx;
				color: #004096;
			}
		}
	}
</style>